import { capitalCase } from "change-case";

export const enumToValueOptions = (enumValues) => {
  return Object.keys(enumValues).map((key) => ({
    label: capitalCase(key),
    value: key,
  }));
};
